import { setTerms } from './helpers';

export const setCoworkingId = setTerms('coworking_id');
